import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  OilFieldStoreActions,
  OilFieldStoreSelectors,
  OilFieldStoreReducer,
} from './index';
import { OilFieldDto } from '@cradua/data';

@Injectable()
export class OilFieldFacade {
  constructor(
    private store: Store<OilFieldStoreReducer.OilFieldPartialState>
  ) {}

  oilFieldRecord$ = this.store.select(OilFieldStoreSelectors.getSelected);
  oilFieldRecordError$ = this.store.select(
    OilFieldStoreSelectors.getOilFieldError
  );

  getselected() {
    return this.store.select(OilFieldStoreSelectors.getSelected);
  }

  get isLoadingOilField() {
    this.store.dispatch(OilFieldStoreActions.loadOilField());
    return this.store.select(OilFieldStoreSelectors.loadingOilField);
  }

  get loadOilField() {
    this.store.dispatch(OilFieldStoreActions.loadOilField());
    return this.store.select(OilFieldStoreSelectors.getAllOilField);
  }

  addOilField(newOilField: OilFieldDto[]) {
    this.store.dispatch(OilFieldStoreActions.addOilField({ newOilField }));
  }

  updateOilField(updateOilField: OilFieldDto[]) {
    this.store.dispatch(
      OilFieldStoreActions.updateOilField({ updateOilField })
    );
  }

  removeOilField(ids: string[]) {
    this.store.dispatch(OilFieldStoreActions.removeOilField({ ids }));
  }
}
